module.exports = {"body":"<center>\n<video width=\"320px\" height=\"240px\" autobuffer=\"autobuffer\" autoplay=\"autoplay\" controls=\"controls\">\n    <source src=\"menstis.m4v\" type=\"video/mp4\">\n</video>\n</center>"}


//////////////////
// WEBPACK FOOTER
// ./blog/2015-01-04-Archief20Jaar/movie.md
// module id = 966
// module chunks = 0